module.exports = __webpack_public_path__ + "assets/img/government.b3a3c88b.png";